import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function fetchWithTimeout(url, options = {}, ms = 2500) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), ms);
  return fetch(url, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(id));
}

function AutoLogin() {
  const navigate = useNavigate();
  const location = useLocation();

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch {
      return null;
    }
  };

  const isExpired = (token) => {
    const decoded = parseJwt(token);
    if (!decoded?.exp) return true;
    return Date.now() >= decoded.exp * 1000;
  };

  useEffect(() => {
    const run = async () => {
      const token = localStorage.getItem("authToken");
      const refreshToken = localStorage.getItem("refreshToken");

      // 둘 다 없으면 로그인
      if (!token && !refreshToken) {
        sessionStorage.removeItem("backendDown");
        navigate("/login");
        return;
      }

      // refresh 만료면 강제 로그아웃
      if (refreshToken && isExpired(refreshToken)) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        sessionStorage.removeItem("backendDown");
        navigate("/login");
        return;
      }
      
      // ✅ 백엔드 생존 체크 (여기서 죽어있으면 대시보드 진입 막기)
      try {
        const res = await fetchWithTimeout("/account/health/", {
          method: "GET",
        }, 2000);

        if (!res.ok) throw new Error("health not ok");
        sessionStorage.removeItem("backendDown");
      } catch {
        sessionStorage.setItem("backendDown", "1");
        if (location.pathname !== "/login") navigate("/login", { replace: true });
        return;
      }
    };

    run();
  }, [location.pathname, navigate]);

  return null;
}

export default AutoLogin;